<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-th-list"></i>
        WSFinder & WMDS Detect
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WFDetector</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">detect</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">Installed_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Group Name</label>
        </b-col>
        <b-col v-if="group_name" class="col-xl-3 col-md-12 align-self-center">
          <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name"></b-form-input>
        </b-col>
        <b-col v-if="group_name" class="col-xl-1 col-md-12 align-self-center">
          <b-button size="sm" id="ph_clear_group" variant="warning" @click="clearChain('group')">Clear</b-button>
        </b-col>
        <b-col v-else class="col-xl-4 col-md-12 align-self-center">
          <b-button variant="add" @click="chainGroup = true">Select Group</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_version">Action</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <!-- <v-select :disabled="action_list.length == 0" label="Action" v-model="so.opt['action']" :options="action_list"></v-select> -->
            <select class="form-control" label="Action" v-model="so.opt['action']">
              <option v-for="item in action_list" :disabled="action_list.length == 0" :key="item" :value="item" >{{item}}</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_type">Solution</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <select class="form-control" label="Action" v-model="so.opt['type']">
              <option value="wsfinder">WSFinder</option>
              <option value="wmds">WMDS</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_target">Target</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="so.opt['target']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group class="float-right">
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
      </b-col>
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">Search</option>
              <option value="type">Type</option>
              <option value="target">Target</option>
            </select>
          </div>
          <div class="mb7 mr-2">
            <select class="form-control" v-model="so.sv" v-if="so.sk == 'type'" @change="refresh">
              <option disabled value="">Please select solution</option>
              <option value="wmds">WMDS : Web Malware Detection System</option>
              <option value="wsfinder">WSFinder : WeShell Finder</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input class="form-control col-xl-12" :disabled="so.adv" v-if="so.sk != 'type'" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" v-if="so.skt != 'action'" variant="outline-secondary" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <div class="custom-control custom-checkbox">
              <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
            </div>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="limit" @change="$refs._list.refresh()">
              <option disabled value="20">Please select display count : Default 20</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>

            <select v-if="sync.enable" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
            <!-- <template slot="info" slot-scope="row">{{row.item.agent|}}</template> -->
            <template slot="action" slot-scope="row">
              {{row.item.type != 'WMDS' ? codes.agent_forgery[row.item.action] || row.item.action : '-'}}
              <!--
                * Todo : row.item.type 이 소문자라서 발생한 오류이므로 수정완료 
                * 해당 부분 현재 진행하지않으며 나중에 진행예정
              -->
              <!-- <b-button size="sm" v-if="row.item.type == 'WMDS'" :variant="row.item.select ? 'danger' : 'add'" @click="row.item.select = true; detail(row.item)" >More</b-button> -->
            </template>
            <template slot="target" slot-scope="row">
              <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target}}</span>
              <span v-else-if="row.item.target_type">
                  [{{row.item.target_type}}]
                  <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
                    {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
                  </span>
                  <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
                    {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
                  </span>
                <span v-else>
                  {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
                </span>
                {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
              </span>
              <span v-else>
                {{row.item.target ? row.item.target : row.item.path }}
              </span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">" />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
    <b-card v-if="model && model.id">
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto mb7">
          [#:{{model.id}}] {{model.target}}
        </div>
        <div class="mb7">
          {{model.created_at | sdate}}
        </div>
      </div>
      <hr>
      <b-row class="mt-3">
        <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
          <b-button style="width:100%" :variant="view_html ? 'add' : 'primary'" @click="view_html = !view_html" >View HTML : {{view_html ? 'On' : 'Off'}}</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
          <span class="text-danger">
            * If the html reference is incorrect or the code is incorrect, the system may not be able to convert to the html page.
          </span>
        </b-col>
      </b-row>
      <b-form-group class="mt-4">
        <pre v-if="!view_html" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" id="ph_now_snapshot">{{model.now_snapshot}}</pre>
        <pre v-else v-html="model.now_snapshot" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" id="ph_now_sanpshot_html"></pre>
      </b-form-group>
    </b-card>
  
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>
  
    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
  </template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>